import React, { useState, useEffect } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Icons } from "./Icons";
import moment from "moment";
import { CheckCircle } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

const style = {
  display: 'flex',
  flexDirection: 'column',
};

function ModalTrazabilidad(props: { children?: any; window?: any; uuid: string; urlOrigen?: string; }) {



  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false)
  const [dataTrazabilidad, setDataTrazabilidad] = useState([])
  const handleCloseForm = () => setModalVisible(false);
  const handleDetail = () => {
    if (props.urlOrigen) {
      localStorage.setItem("urlOrigen", props.urlOrigen!);
    }
    navigate("/trazabilidad/" + props.uuid);
  }
  const getTrazabilidad = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_APPLICATION_ENDPOINT +
        "/trazabilidad/info/" + props.uuid,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken") || "",
      }
    })
      .then(({ data }) => {
        setDataTrazabilidad(data)
        setModalVisible(true)
      })
      .catch(function (error) {
        Swal.fire({
          icon: "error",
          title: "Mensaje",
          text:
            "(" + error.response?.status + ") " + error.response?.data?.message,
        })
      });

  };

  return (
    <>
      <Tooltip title=" Trazabilidad" sx={{ cursor: 'pointer' }} onClick={getTrazabilidad}>
        {Icons("QueryStats")}
      </Tooltip>
      <Dialog
        open={modalVisible}
        onClose={handleCloseForm}
      >
        <DialogTitle>
          <Grid container sx={{ width: '98%' }}>
            <Grid item xs={10}>
              <Typography>Trazabilidad.</Typography>
            </Grid>
            <Grid item xs={2}>
              <Button
                onClick={handleCloseForm}
                variant="text"
              >
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container mt={2}>
            <Grid item xs={12}>
              {
                dataTrazabilidad.length > 0 &&
                dataTrazabilidad.map((res: any) => (
                  <Box key={res.uuid} sx={{ borderBottom: '1px solid gray', paddingBottom: 1, paddingTop: 1, paddingLeft: 1 }}>
                    <Typography sx={{ fontSize: 15, color: "#AF8C55", fontWeight: '900' }}>
                      <CheckCircle style={{ color: 'black', fontSize: 16 }} /> {res.proceso_nombre}
                    </Typography>
                    <Box sx={{ borderLeft: '1px solid black', paddingBottom: 1, paddingTop: 1, paddingLeft: 1, marginLeft: 1 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: '600' }}>{res.nombreCompleto}</Typography>
                      <Typography sx={{ fontSize: 12, color: "gray" }}>{moment.utc(res.fecha_inicio).format('DD/MM/YY hh:mm a')}</Typography>
                    </Box>
                  </Box>
                ))
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* <Button
            variant="contained"
            sx={{
              "&:hover": {
                color: "#15212f",
              },
            }}
            onClick={handleDetail}
          >
            Ver Más
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
}

ModalTrazabilidad.propTypes = {
  window: PropTypes.func,
};
export default ModalTrazabilidad;
